export default {
  mapLeftClick: {
    'placeInfo': 'Informazioni sul luogo',
    'placeInsidePolygon': 'Luogo nel poligono',
    'polygonArea': 'Area poligono',
    'copyLnglat': 'Copia long., lat.',
    'copyLatlng': 'Copia lat., long.',
    'directionsToClickedPoint': 'Clicca per arrivare al punto scelto',
    'lnglatCopied': 'Longitudine e latitudine copiate',
    'latlngCopied': 'Latitudine e longitudine copiate'
  }
}
